








import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      clientIsAuthenticated: "auth/client/isAuthenticated"
    })
  }
})
export default class NavigationRibbon extends Vue {
  public get routes() {
    return this.clientIsAuthenticated ? this.defaultRoutes : this.guestRoutes;
  }

  // !!IMPORTANT - 'Path' required here for mobile selectbox

  public defaultRoutes: any = [
    {
      label: "_.products_and_services",
      to: { path: `/products` }
    },
    {
      label: "_.billing",
      to: { path: "/billing" }
    },
    {
      label: "_.my_account",
      to: { path: "/account" }
    },
    {
      label: "_.support",
      to: { path: "/support" }
    },
    {
      if: () => this.$store.getters["brand/showStore"],
      label: "_action.place_new_order",
      to: { path: `/order` }
    }
  ];

  public guestRoutes: any = [
    {
      label: "_.register",
      to: { path: `/register` }
    },
    {
      label: "_.login",
      to: { path: `/login` }
    }
  ];
  private clientIsAuthenticated!: boolean;
}
